import { useEffect } from "react";

/**
 * Lightweight SEO updater: sets <title>, meta description, canonical, and OG tags.
 * Cleans up nothing (next page will overwrite).
 */
function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(url) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", url);
}

export default function SEO({ title, description, path = "/", jsonLd }) {
  useEffect(() => {
    const fullTitle = title || "Veterans for Indiana";
    document.title = fullTitle;
    setMeta("description", description);
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", description, "property");
    setMeta("og:url", `https://www.veteransforindiana.com${path}`, "property");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", description);
    setCanonical(`https://www.veteransforindiana.com${path}`);

    // Inject page-specific JSON-LD (with cleanup)
    let scriptEl;
    if (jsonLd) {
      scriptEl = document.createElement("script");
      scriptEl.type = "application/ld+json";
      scriptEl.text = JSON.stringify(jsonLd);
      scriptEl.dataset.seoPage = "1";
      document.head.appendChild(scriptEl);
    }
    // Scroll to top on navigation
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });

    return () => {
      if (scriptEl && scriptEl.parentNode) scriptEl.parentNode.removeChild(scriptEl);
    };
  }, [title, description, path, jsonLd]);

  return null;
}
